import { FC, useContext, useEffect, useState } from 'react';
import { AppContext } from '../../context/AppProvider';
import { apis } from '../../services/alm';
import { getAlmToken, updateLanguageSetting } from '../../services/user';
import { ActionType } from '../../assets/constants/constants';
const withRegtrationToken = (Component: FC<any>) => (props: any) => {
  const {state, dispatch} = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (state.initApp === false && state.isAuthenticated == true) {
      setLoading(true);
      setAlmToken();
    }
  }, [state.initApp]);

  const setAlmToken = async() => {
    await  getAlmToken().then( async (learnerRes: any) => {
            dispatch({type: ActionType.IS_AUTH, payload: true});
          localStorage.setItem('access_token', learnerRes.data.access_token ? learnerRes.data.access_token : '');
          await apis.updateUserContent(learnerRes?.data?.user_id,localStorage.getItem('locale'));
          await updateLanguageSetting(localStorage.getItem('locale'));
      })
    await apis
        .checkAlmUser()
        .then(res => {
          const result = res?.data;
          const userInfo = {...result.attributes, userId: result?.id};
          dispatch({type: ActionType.EU_ALM_USER_INFO, payload: userInfo});
          setLoading(false);
        })
        .catch(() => {
          dispatch({type: ActionType.INIT_APP, payload: false});
        });  
      
  };
  return !loading && <Component {...props} />;
};

export default withRegtrationToken;
